import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export enum Product {
  RE = 'reading-eggs',
  REX = 'reading-eggspress',
  FP = 'fast-phonics',
  MS = 'mathseeds',
  MSP = 'mathseeds-prime',
  WL = 'writing-legends',
}

export function isProduct(maybeProduct: unknown): maybeProduct is Product {
  const valid = Object.values<string>(Product)
  return typeof maybeProduct === 'string' && valid.includes(maybeProduct)
}

function assertUnreachable(input: unknown): never {
  throw new Error(`Received an unknown subscription type: ${typeof input === 'string' ? input : '(not a string)'}`)
}

export function productBackgroundColor(product: Product): string {
  switch (product) {
    case Product.RE:
      return 'bg-oceany-blue-50'
    case Product.REX:
      return 'bg-rexy-purple-50'
    case Product.MS:
      return 'bg-ms-green-50'
    case Product.MSP:
      return 'bg-yellow-25'
    case Product.FP:
      return 'bg-fp-purple-300'
    case Product.WL:
      return 'bg-wl-blue-50'
    default:
      return 'bg-white'
  }
}

export function defaultProductForSubscriptionType(subscriptionType: SubscriptionType): Product {
  switch (subscriptionType) {
    case SubscriptionType.Reading:
      return Product.RE
    case SubscriptionType.Maths:
      return Product.MS
    case SubscriptionType.Writing:
      return Product.WL
    default:
      assertUnreachable(subscriptionType)
  }
}
